import { render, staticRenderFns } from "./CorporateAccount.vue?vue&type=template&id=23344be4"
import script from "./CorporateAccount.vue?vue&type=script&lang=js"
export * from "./CorporateAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports